import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as actions from "../../actions/login.action";
import { Formik } from "formik";
import { httpClient } from "../../utils/HttpClient";
import jwt_decode from "jwt-decode";
import { message } from 'antd';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput 
} from "shards-react";

class Login extends Component {
  constructor() {
    super();

    this.state = {
      signinUrl: "",
      isLoggedIn: false,
      email: ""
    };
  }

  async componentDidMount() {
    localStorage.clear();

    if (localStorage.getItem("token")) {
      this.setState({ isLoggedIn: true });
    } else {
      await this.props.getSigninUrl(); //Get Microsoft Signin Url

      const { url, isFetching } = this.props.loginReducer;

      if (!isFetching && url) this.setState({ signinUrl: url.data });
    }
  }

  renderTargetOption() {
    let optionList = [
      {
        value: "",
        label: "เลือกวิธีการ Log In",
      },
      {
        value: "microsoft",
        label: "Log In โดยใช้ Microsoft Account",
      },
      {
        value: "username",
        label: "Log In โดยใช้ Username",
      },
    ];

    let optionElements = optionList.map((item) => (
      <option value={item.value} key={item.value}>
        {item.label}
      </option>
    ));

    return optionElements;
  }

  async loginWithEmail()  {
    if(!this.state.email)  {
      message.error('กรุณากรอกอีเมล');

      return
    }
    
    try {
      const response = await httpClient.post(
        `/api/authentication/email`,
        { 
          email: this.state.email 
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      localStorage.setItem("token", response.data)
      const user = jwt_decode(response.data);
      localStorage.setItem('user_profile',JSON.stringify(user));      

      this.props.history.push(`/meeting/user/view`)
    } catch(err)  {
      if(err.response.status === 404) {
        message.error('ไม่พบอีเมลนี้ในระบบ');
      }
    }
  }

  showForm = ({ values, handleChange, handleSubmit, isSubmitting }) => {
    return (
      <Container fluid className="mx-auto mt-5 pt-5">
        <Row noGutters className=" h-auto">
          <Col lg="3" md="6" className="mx-auto">
            <Card>
              <Form className="form-horizontal">
                <CardBody>
                  <img
                    className="d-table mx-auto mb-3"
                    src={require("../../assets/img/Logo.png")}
                    style={{ height: 150 }}
                    alt="Arda Logo"
                  />

                  <h4 className="auth-form__title text-center mb-4 font-weight-bold text-main">
                    ARDA E-Meeting
                  </h4>

                  <FormGroup className="mt-2">
                    <FormInput
                      name="email"
                      id="email"
                      placeholder="อีเมลแอดเดรส"
                      value={this.state.email}
                      onChange={(e) => this.setState({email: e.target.value})}
                    />
                  </FormGroup>

                  <FormGroup>
                    <button
                      type="button"
                      className="btn btn-secondary btn-block mt-4"
                      onClick={() => this.loginWithEmail()}
                    >
                      เข้าสู่ระบบด้วยอีเมล (สำหรับผู้เข้าประชุม)
                    </button>
                  </FormGroup>

                  <div className="text-muted text-center mt-4 d-flex align-items-center">
                    <span className="flex-fill" style={{height: 1, background: '#e6eaee'}}></span>
                    <span className="px-3 bg-white">หรือ</span>
                    <span className="flex-fill" style={{height: 1, background: '#e6eaee'}}></span>
                  </div>

                  <FormGroup>
                    <a
                      href={this.state.signinUrl}
                      className="btn btn-primary btn-block mt-4"
                    >
                      เข้าสู่ระบบ (สำหรับผู้จัดการประชุม)
                    </a>
                  </FormGroup>                  

                  {/* <FormSelect
                    name="pushTarget"
                    id="pushTarget"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={values.pushTarget}
                  >
                    {this.renderTargetOption()}
                  </FormSelect>

                  {values.pushTarget === "microsoft" ? (
                    <FormGroup>
                      <a
                        href={this.state.signinUrl}
                        className="btn btn-primary btn-block d-table mt-4"
                      >
                        เข้าสู่ระบบด้วย Office 365
                      </a>
                    </FormGroup>
                  ) : null}

                  {values.pushTarget === "username" ? (
                    <React.Fragment>
                      <FormGroup className="mt-2">
                        <label htmlFor="username">Username</label>
                        <FormInput
                          name="user_username"
                          id="user_username"
                          placeholder="Enter Username"
                        />
                      </FormGroup>

                      <FormGroup>
                        <label htmlFor="password">Password</label>
                        <FormInput
                          name="user_password"
                          id="user_password"
                          type="password"
                          id="password"
                          placeholder="Enter Password"
                        />
                      </FormGroup>

                      <FormGroup>
                        <button
                          type="button"
                          className="btn btn-primary btn-block d-table mt-4"
                        >
                          LOG IN
                        </button>
                      </FormGroup>
                    </React.Fragment>
                  ) : null} */}
                </CardBody>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    if (this.state.isLoggedIn) return <Redirect to="/meeting" />;
    else {
      return (
        <React.Fragment>
          <Formik
            initialValues={{
              user_username: "",
              user_password: "",
            }}
            onSubmit={async (values, { setSubmitting }) => {
              // const params = {
              //   user_username: values.user_username,
              //   user_password: values.user_password,
              // };

              //this.props.login(this.props.history, params);

              setSubmitting(false);
            }}
          >
            {(props) => this.showForm(props)}
          </Formik>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  loginReducer,
});

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
